import { IKeHoachTuanCreateRequest } from "../../model/request/ke-hoach/IKeHoachTuanCreateRequest";
import { apiClient } from "../apiClient";
import { KE_HOACH_NAM_ENDPOINT } from "./keHoachNamApi";
export const KE_HOACH_KY_ENDPOINT = "ke-hoach-tuan";
export const keHoachTuanApi = {
  SelectByKeHoachNam: (id_kh: number) => apiClient.get(`${KE_HOACH_NAM_ENDPOINT}/${id_kh}/tuan`),
  CreateByNam: (payload: IKeHoachTuanCreateRequest) => apiClient.put(`${KE_HOACH_KY_ENDPOINT}`, payload),
};
